import { inject, Injectable } from '@angular/core';
import { Action, dispatch, NgxsOnInit, Selector, State, StateContext } from '@ngxs/store';
import { AuthHttpService } from 'app/services/auth.http.service';
import * as Actions from './auth.actions';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, from, switchMap, tap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ToastService } from 'app/services/toast.service';


export type LoaderKey =
  | 'basicAuth';
export interface AuthStateModel {
  loaders: Record<LoaderKey, boolean>;
  accessToken?: string;
}

const defaults: AuthStateModel = {
  loaders: {
    basicAuth: false,
  },
  accessToken: undefined,
}

type Model = AuthStateModel;
type Context = StateContext<Model>;
@State<Model>({
  name: 'auth',
  defaults,
})
@Injectable()
export class AuthState implements NgxsOnInit {
  ngxsOnInit(ctx: StateContext<Model>): void {
    ctx.patchState({ accessToken: localStorage.getItem('accessToken') || undefined });
  }
  private authHttpService = inject(AuthHttpService);
  private router = inject(Router);
  private toastService = inject(ToastService);
  @Selector()
  static loaders(state: Model): Record<LoaderKey, boolean> {
    return state.loaders;
  }

  @Selector()
  static authTokens(state: Model): { accessToken?: string } {
    return { accessToken: state.accessToken };
  }

  @Action(Actions.Login)
  login({ patchState, dispatch }: Context, { payload }: Actions.Login) {
    patchState({ loaders: { ...defaults.loaders, basicAuth: true } });
    return from(this.authHttpService.login(payload)).pipe(
      switchMap(({ accessToken }) => dispatch(new Actions.SetTokens(accessToken))),
      catchError((error) => dispatch(new Actions.ApiError(error))),
    )
  }

  @Action(Actions.SetTokens)
  setTokens({ patchState }: Context, { accessToken }: Actions.SetTokens) {
    patchState({ accessToken });
    localStorage.setItem('accessToken', accessToken);
    patchState({ loaders: defaults.loaders });
    return this.router.navigate(['/dashboard']);
  }

  @Action(Actions.Logout)
  logout({ patchState }: Context) {
    patchState({ accessToken: undefined });
    localStorage.removeItem('accessToken');
    return this.router.navigate(['/auth']);
  }

  @Action(Actions.ApiError)
  public apiError({ patchState }: Context, { error }: Actions.ApiError) {
    patchState({ loaders: defaults.loaders });
    this.toastService.error({ title: 'Ошибка', subtitle: (error instanceof HttpErrorResponse ? error.error.message : error) || 'Что-то пошло не так' });
    return throwError(() => error);
  }
}
